import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {GlobalService} from '../../global.service';
import {observableToBeFn} from 'rxjs/internal/testing/TestScheduler';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  constructor(private httpClient: HttpClient,
              private globalService: GlobalService) { }


  getDriverRatings(country, license, sim) {

    return this.httpClient.get(this.globalService.apiUrl + '/statistics/rating?country=' + country + '&license=' + encodeURIComponent(license) + '&sim_id=' + sim, {observe: 'events'});

  }

  getCommunitySpread() {
    return this.httpClient.get(this.globalService.apiUrl + '/statistics/usersByOrigin');
  }

  getLapTimeDistribution(track, cls) {
    return this.httpClient.get(this.globalService.apiUrl + '/statistics/lapTimeDistribution/' + track + '/' + cls);
  }

  getDriverPerformance(sort, country) {

    return this.httpClient.get(this.globalService.apiUrl + '/statistics/driverperformance?sort=' + sort + '&country=' + country, {observe: 'events'});

  }

  getUserRegistrations() {

    return this.httpClient.get(this.globalService.apiUrl + '/statistics/getUserRegistrations');

  }

  getDriverSafetyRatings() {

    return this.httpClient.get(this.globalService.apiUrl + '/statistics/safetyrating' , {observe: 'events'});

  }

  getMostActive() {

    return this.httpClient.get(this.globalService.apiUrl + '/statistics/mostActive' , {observe: 'events'});

  }

  getMostUsedCars() {

    return this.httpClient.get(this.globalService.apiUrl + '/statistics/carUsage');

  }

  getCarStats(carclass, season, track, sim, elo = 0) {

    return this.httpClient.get(this.globalService.apiUrl + '/statistics/carStats?class=' + carclass + '&season=' + season + '&track=' + track + '&sim=' + sim + '&elo=' + elo);

  }

  getSeasonTracks(season, sim) {
    return this.httpClient.get(this.globalService.apiUrl + '/statistics/getRacedTracksFromSeason?season=' + season + '&sim=' + sim);
  }


  getTrackData(id) {
    return this.httpClient.get(this.globalService.apiUrl + '/tracks/details/' + id , {observe: 'events'});
  }

  getEloDistribution() {
    return this.httpClient.get(this.globalService.apiUrl + '/statistics/getEloDistribution');
  }

  getSRDistribution() {
    return this.httpClient.get(this.globalService.apiUrl + '/statistics/getSRDistribution');
  }

}
